import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Head from 'next/head';
import Image from 'next/image';
import React from 'react';
import { H1 } from 'src/base/texts/H1';
import { H2 } from 'src/base/texts/H2';
import { P } from 'src/base/texts/P';
import { FeatureBox } from 'src/components/features/FeatureBox';
import { FeatureStep } from 'src/components/features/FeatureStep';
import withFreeLayout from 'src/components/layout/FreeLayout';

const containerStyle: React.CSSProperties = {
  backgroundColor: 'white',
  paddingTop: 15,
  maxWidth: 1000,
};

function Maintenance(): JSX.Element {
  return (
    <>
      <Head>
        <title>Maintenance - Marble Virtual Rental Management</title>
        <meta
          name="description"
          content="Learn more about Marble's 24/7 maintenance dispatch program"
        />
      </Head>
      <Container style={containerStyle}>
        <Grid container>
          <Grid item md style={{ display: 'flex' }}>
            <div
              style={{
                marginTop: 'auto',
                marginBottom: 'auto',
                paddingLeft: 15,
                paddingRight: 15,
              }}
            >
              <H1>Maintenance</H1>
              <div style={{ marginBottom: 20 }}>
                <P align="left">
                  Spend less time on maintenance and more time on the things
                  that matter. Marble can help you improve tenant happiness and
                  protect your investment.
                </P>
              </div>
            </div>
          </Grid>
          <Grid item md style={{ textAlign: 'left', display: 'flex' }}>
            <Image
              style={{ borderRadius: 8 }}
              width={450}
              height={300}
              src="/img/handyman.webp"
              alt="Handyman fixing a window for a house"
            />
          </Grid>
        </Grid>
      </Container>

      <Container style={{ marginTop: 70 }}>
        <H2 style={{ textAlign: 'center', marginBottom: 50 }}>Key Features</H2>
        <FeatureBox
          header="We Find Contractors For You"
          descr="We’ll dispatch a verified service provider or we can dispatch your own preferred vendors"
          reverseImgOrder
        >
          <Image
            src="/img/search-contractors.webp"
            style={{ borderRadius: 8 }}
            width={450}
            height={300}
            alt="Contractor searching for supplies"
          />
        </FeatureBox>

        <FeatureBox
          header="We'll Take The Calls"
          descr="Never get woken up at night again. Our 24/7 operations center will handle all tenant calls and requests on your behalf. Emergencies will be handled promptly to protect your property."
        >
          <Image
            src="/img/support-agent2.webp"
            style={{ borderRadius: 8 }}
            width={450}
            height={300}
            alt="Support agent answering calls questions for a customer"
          />
        </FeatureBox>

        <FeatureBox
          header="Transparency Through The Entire Process"
          descr="Our software tracks maintenance coordination in real time. You get an online portal and email notifications throughout the process. Always know the status of a maintenance request."
          reverseImgOrder
        >
          <Image
            src="/img/transparency.webp"
            style={{ borderRadius: 8 }}
            width={450}
            height={300}
            alt="User browsing a mobile application"
          />
        </FeatureBox>
      </Container>

      <Container style={{ marginTop: -30, marginBottom: 100 }}>
        <div style={{ textAlign: 'center' }}>
          <H2>How It Works</H2>
        </div>
        <FeatureStep
          number="1"
          text="Tenants call or text us with any maintenance requests"
        />
        <FeatureStep
          number="2"
          text="We screen for emergencies with our experienced team and powerful software"
        />
        <FeatureStep
          number="3"
          text="Deep dive troubleshooting with our maintenance experts over the phone to prevent unnecessary dispatches"
        />
        <FeatureStep
          number="4"
          text="Dispatch a contractor to resolve the issue. We can use your favorite contractor or one from our contractor network"
        />
        <FeatureStep
          number="5"
          text="We contact you if the price for repairing is outside of your spend limit"
        />
        <FeatureStep
          number="6"
          text="Follow up with the contractor and tenant to make sure the issue is resolved"
        />
      </Container>
    </>
  );
}

export default withFreeLayout(Maintenance);
